import { Card } from '@cocoonspace/ui/components/card'
import { useLingui } from '@lingui/react/macro'

import { useUserContext } from '~/providers/user-provider'

export const Referal = () => {
	const { t } = useLingui()
	const { accountQuery } = useUserContext()

	const godFatherCode = accountQuery.data?.godfather_code

	return (
		<Card className='flex flex-col gap-2 p-4'>
			<div className='flex flex-col'>
				<div className='font-bold'>{t`Mon code parrainage`}</div>

				<div className='text-muted-foreground text-sm leading-none'>
					{t`Offrez 1h et gagnez 1h offerte !`}
				</div>
			</div>

			<div className='text-primary flex flex-1 items-center justify-center text-center text-2xl font-bold'>
				{godFatherCode}
			</div>
		</Card>
	)
}
